import { useAnonymousUserName } from "@bounce/store"

export type UseReviewUsernameOptions = {
  review: {
    user: {
      fullName?: string | null
    }
  }
}

export const useReviewUsername = ({ review }: UseReviewUsernameOptions) => {
  const anonymous = useAnonymousUserName()

  return review.user.fullName || anonymous
}
